import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/table';
import { ShieldAlert, MapPin } from 'lucide-react';
import { StatusBadge } from './shared';

export const EmergenciesTab = ({ emergencyRequests }) => {
  return (
    <Card className="border-0 shadow-lg">
      <CardHeader>
        <CardTitle className="text-xl flex items-center gap-2">
          <ShieldAlert className="w-5 h-5 text-[#C81D25]" />Solicitudes de Emergencia
        </CardTitle>
        <CardDescription>Historial de solicitudes de ambulancia</CardDescription>
      </CardHeader>
      <CardContent>
        {emergencyRequests.length === 0 ? (
          <div className="text-center py-16 text-gray-400">
            <ShieldAlert className="w-12 h-12 mx-auto mb-4 opacity-30" />
            <p className="text-lg font-medium">No hay solicitudes de emergencia registradas</p>
            <p className="text-sm">Las solicitudes aparecerán aquí cuando los usuarios activen el servicio SOS</p>
          </div>
        ) : (
          <Table>
            <TableHeader>
              <TableRow className="bg-gray-50">
                <TableHead>Usuario</TableHead>
                <TableHead>Email</TableHead>
                <TableHead>Teléfono</TableHead>
                <TableHead>Estado</TableHead>
                <TableHead>Ubicación</TableHead>
                <TableHead>Fecha</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {emergencyRequests.map((req) => (
                <TableRow key={req.id}>
                  <TableCell className="font-medium">{req.user_name}</TableCell>
                  <TableCell className="text-gray-500">{req.user_email}</TableCell>
                  <TableCell className="text-gray-500">{req.user_phone || '-'}</TableCell>
                  <TableCell><StatusBadge status={req.status === 'requested' ? 'pending' : req.status} /></TableCell>
                  <TableCell>
                    <a href={`https://www.google.com/maps?q=${req.location_lat},${req.location_lng}`} target="_blank" rel="noopener noreferrer"
                      className="inline-flex items-center gap-1 text-blue-600 hover:underline text-sm">
                      <MapPin className="w-3 h-3" />Ver mapa
                    </a>
                  </TableCell>
                  <TableCell className="text-gray-500 text-sm">{new Date(req.created_at).toLocaleString('es-MX')}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
};
